'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _SmartBool = require('../../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _common = require('../../common');

var _ConfirmDelete = require('../../common/ConfirmDelete');

var _ConfirmDelete2 = _interopRequireDefault(_ConfirmDelete);

var _containers = require('../../../containers');

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GuardedDeleteSMSSavedReplyButton = (0, _containers.createGuardedContainer)({
  permissionName: _constants.AppConstants.PERMISSIONS.DELETE_SMS_SAVED_REPLY,
  enabledComponent: _Button2.default,
  disabledComponent: (0, _containers.createDisabledContainer)(_Button2.default)
});

var SMSSavedReplyDropdownItem = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(SMSSavedReplyDropdownItem, _Component);

  function SMSSavedReplyDropdownItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SMSSavedReplyDropdownItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SMSSavedReplyDropdownItem.__proto__ || Object.getPrototypeOf(SMSSavedReplyDropdownItem)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showDeleteConfirmation', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SMSSavedReplyDropdownItem, [{
    key: 'onSMSSavedReplyClick',
    value: function onSMSSavedReplyClick() {
      var _props = this.props,
          onSelect = _props.onSelect,
          onSMSSavedReplyClick = _props.onSMSSavedReplyClick,
          smsSavedReply = _props.smsSavedReply;


      onSMSSavedReplyClick(smsSavedReply);
      onSelect();
    }
  }, {
    key: 'onDeleteSMSSavedReply',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var _props2, onDeleteSMSSavedReply, smsSavedReply;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, onDeleteSMSSavedReply = _props2.onDeleteSMSSavedReply, smsSavedReply = _props2.smsSavedReply;


                event.preventDefault();
                _context.next = 4;
                return onDeleteSMSSavedReply(smsSavedReply);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDeleteSMSSavedReply(_x) {
        return _ref2.apply(this, arguments);
      }

      return onDeleteSMSSavedReply;
    }()
  }, {
    key: 'render',
    value: function render() {
      var smsSavedReply = this.props.smsSavedReply;


      return _react2.default.createElement(
        _MenuItem2.default,
        null,
        _react2.default.createElement(_ConfirmDelete2.default, {
          message: 'Delete ?',
          onClickDelete: this.onDeleteSMSSavedReply,
          onClickCancel: this.showDeleteConfirmation.setFalse,
          showConfirmDelete: this.showDeleteConfirmation.isTrue,
          small: true
        }),
        _react2.default.createElement(
          _Button2.default,
          {
            bsStyle: 'link',
            className: 'no-padding sms-saved-reply-select-button',
            onClick: this.onSMSSavedReplyClick
          },
          smsSavedReply.name
        ),
        _react2.default.createElement(
          GuardedDeleteSMSSavedReplyButton,
          {
            bsStyle: 'link',
            className: 'btn-delete-sms-saved-reply no-padding',
            onClick: this.showDeleteConfirmation.setTrue
          },
          _react2.default.createElement(_common.Icon, { type: 'trash' })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SMSSavedReplyDropdownItem;
}(_react.Component), _class3.propTypes = {
  onSMSSavedReplyClick: _propTypes2.default.func.isRequired,
  onDeleteSMSSavedReply: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func,
  smsSavedReply: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showDeleteConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
})), _class2)) || _class) || _class;

var _default = SMSSavedReplyDropdownItem;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GuardedDeleteSMSSavedReplyButton, 'GuardedDeleteSMSSavedReplyButton', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdownItem.jsx');
  reactHotLoader.register(SMSSavedReplyDropdownItem, 'SMSSavedReplyDropdownItem', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdownItem.jsx');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/sidebar-feed/SMSSavedReplyDropdownItem.jsx');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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